export default function ({ $gtm, app }) {
  $gtm.init(app.$appConfig.googleMeasurementId)
}
